import { ApiService } from "../../../../../core";
import { PaymentAdsSubscriptionResponse, PaymentController, PaymentRequestResponse, PaymentSubscriptionResponse, RequestAdsPaymentData, RequestPaymentData, SubscriptionType } from "../../core";

export class PaymentControllerImpl implements PaymentController {
    private api;
    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }
    async onLoad(subscriptionId: string, subscriptionFrequency: string): Promise<PaymentSubscriptionResponse> {
        try {
            const formData = new FormData();
            formData.append("plan_id", subscriptionId);
            formData.append("frequency", subscriptionFrequency);
            const data: PaymentSubscriptionResponse = await this.api.post('/payment-subscription-data', formData)
            return data;
        } catch (error) {
            if (error?.response?.status === 401) {
                throw ("401");
            } else {
                throw new Error(error.message);
            }
        }
    }

    async onLoadAds(adsPlanId: string): Promise<PaymentAdsSubscriptionResponse> {
        try {
            const formData = new FormData();
            formData.append("plan_id", adsPlanId);
            const data: PaymentSubscriptionResponse = await this.api.post('/payment-subscription-data', formData)
            return data;
        } catch (error) {
            if (error?.response?.status === 401) {
                throw ("401");
            } else {
                throw new Error(error.message);
            }
        }
    }

    async requestPayment(requestData: RequestPaymentData | RequestAdsPaymentData, isToUpdate: boolean | undefined): Promise<PaymentRequestResponse> {
        let preparedData;
        if (isToUpdate) {
            preparedData = this.prepareDataToUpdate(requestData) as Array<string>;
        } else {
            preparedData = this.prepareDataToCreate(requestData) as FormData;
        }

        try {
            const data: PaymentRequestResponse = !isToUpdate
                ? await this.api.post('/payment-request', preparedData)
                : await this.api.put('/subscription-update-chosen', preparedData)
            if (data.success) return data;
            throw new Error(data.response);
        } catch (error) {
            throw new Error(error.message);
        }
    }

    prepareDataToCreate(requestData: RequestPaymentData | RequestAdsPaymentData): FormData {
        const formData = new FormData();
        formData.append("email", requestData.email);
        formData.append("method", requestData.method);
        formData.append("identification", requestData.identification);

        if (SubscriptionType.ADS in requestData) {
            formData.append("ads_id", requestData.ads_id);
        } else if (SubscriptionType.SUBSCRIPTION in requestData) {
            formData.append("frequency", requestData.frequency);
            formData.append("plan_id", requestData.plan_id);
        }
        return formData;
    }

    prepareDataToUpdate(requestData: RequestPaymentData | RequestAdsPaymentData) {
        const prepareRequestData = {};
        prepareRequestData['email'] = requestData.email;
        prepareRequestData['method'] = requestData.method;

        if (SubscriptionType.ADS in requestData) {
            prepareRequestData['ads_id'] = requestData.ads_id;
        } else if (SubscriptionType.SUBSCRIPTION in requestData) {
            prepareRequestData['frequency'] = requestData.frequency;
            prepareRequestData['plan_id'] = requestData.plan_id;
        }

        return prepareRequestData;
    }

}